var instance;

class PartCache {
    constructor(basePath) {
        if(instance){
            return instance;
        }

        instance = this;
        this.basePath = basePath;
        this.modelCache = {};
    }

    getBasePath(){
        return this.basePath;
    }
    setCache(key, value) {
        var that = this;

        if(!(key in that.modelCache)) {
            that.modelCache[key] = value;
        }
    }
    getCache(key, defaultValue) {
        var that = this;

        if (key in that.modelCache) {
            return that.modelCache[key];
        }

        return defaultValue;
    }
}

PartCache.getInstance = function(){
    if(instance){
        return instance;
    }else{
        throw new Error('object must be instanciated first');
    }
};

module.exports = PartCache;


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Models/PartCache.js